/** @jsxImportSource @emotion/react */

import { memo, useRef } from "react";

import { Global, SerializedStyles } from "@emotion/react";
import { SelectProps, Select as SelectComp, MenuItem } from "@material-ui/core";

import { menu, select } from "./styles";

interface Option {
  label: string;
  value: string | number;
}

export interface Props extends SelectProps {
  options: Option[];
  customizeStyle?: {
    select?: SerializedStyles;
    menu?: SerializedStyles;
  };
}

const Select = ({ options, customizeStyle, value, variant = "standard", onChange, ...rest }: Props): JSX.Element => {
  const ref = useRef<any>();
  return (
    <>
      <Global styles={customizeStyle?.menu || menu} />
      <SelectComp
        ref={ref}
        css={customizeStyle?.select || select}
        value={value}
        onChange={onChange}
        MenuProps={{
          variant: "menu",
          anchorEl: () => ref.current,
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
        }}
        variant={variant}
        {...rest}
      >
        {options.map(({ value: optionValue, label }) => (
          <MenuItem value={optionValue}>{label}</MenuItem>
        ))}
      </SelectComp>
    </>
  );
};

export default memo(Select);
